export function encodeToBase64(data: string): string {
  return Buffer.from(data).toString('base64');
}

export function decodeFromBase64(data: string): string {
  return Buffer.from(data, 'base64').toString();
}
